import { config } from '@iheartjane/config';
import { StreamChat } from 'stream-chat';
import {
  Avatar,
  Channel,
  Chat,
  MessageInput,
  MessageList,
  Thread,
  Window,
} from 'stream-chat-react';

import { useConversationContext } from './conversationProvider';
import { CustomMessage } from './customMessage';

import styles from './conversation.module.css';

export const Conversation = () => {
  const chatClient = StreamChat.getInstance(config.streamChatApiToken);
  const { channel, store } = useConversationContext();
  return (
    <Chat client={chatClient}>
      <div className={styles['streamOverrides']}>
        <Channel channel={channel} Message={CustomMessage}>
          <Window>
            <div
              className="str-chat__header-livestream"
              style={{ justifyContent: 'center', flexWrap: 'nowrap' }}
            >
              <Avatar image={store.photo} name={store.name} />
              <p className="str-chat__header-livestream-left--title">
                {store.name}
              </p>
            </div>
            <MessageList />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </div>
    </Chat>
  );
};
